import React from 'react';
import { railsInputName } from 'members/helpers';
import Glyph from 'components/glyph';

class NotificationPreferences extends React.Component {
  render() {
    if (this.props.isEditable) {
      return (
        <EditableNotificationPreferences
          memberId={this.props.memberId}
          receiveUsageEmails={this.props.receiveUsageEmails}
          receiveBillingEmails={this.props.receiveBillingEmails}
          editableNotifications={this.props.editableNotifications}
          paysSomeoneElse={this.props.paysSomeoneElse}
          onCheckboxChange={this.props.onCheckboxChange}
        />
      );
    } else {
      return (
        <ReadOnlyNotificationPreferences
          receiveUsageEmails={this.props.receiveUsageEmails}
          receiveBillingEmails={this.props.receiveBillingEmails}
          noNotificationCss={this.props.noNotificationCss}
          glyph={this.props.glyph}
        />
      );
    }
  }
}



// *********************************************************************************
// Functional components
// *********************************************************************************



// responsible for rendering the email notification section of the form
// *********************************************************************************
function EditableNotificationPreferences(props) {
  return (
    <div className="grid-cell mod-notifications">
      <NotificationPreferenceHeading />
      <p>
        <label>
          <input className="email-preference" type="checkbox" value="1"
            name={railsInputName(props.memberId, 'receive_usage_emails')}
            defaultChecked={props.receiveUsageEmails}
            disabled={!props.editableNotifications}
            onChange={props.onCheckboxChange('receiveUsageEmails')}
          /> Usage
        </label>
      </p>
      {
        !props.paysSomeoneElse &&
          <p>
            <label>
              <input className="email-preference" type="checkbox" value="1"
                name={railsInputName(props.memberId, 'receive_billing_emails')}
                defaultChecked={props.receiveBillingEmails}
                disabled={!props.editableNotifications}
                onChange={props.onCheckboxChange('receiveBillingEmails')}
              /> Billing
            </label>
          </p>
      }
    </div>
  );
}

// responsible for handling the section related to email preferences for
// usage and billing emails
// *********************************************************************************
function ReadOnlyNotificationPreferences(props) {
  return (
    <div className="grid-cell mod-notifications">
      <NotificationPreferenceHeading />
      <p className={props.noNotificationCss(props.receiveUsageEmails)}>
        <Glyph name={props.glyph(props.receiveUsageEmails)} /> <label>Usage</label>
      </p>
      <p className={props.noNotificationCss(props.receiveBillingEmails)}>
        <Glyph name={props.glyph(props.receiveBillingEmails)} /> <label>Billing</label>
      </p>
    </div>
  );
}

// renders the notification preference heading, with "?" tooltip icon
// *********************************************************************************
function NotificationPreferenceHeading() {
  return (<h4>Emails <span className="help-icon" data-pt-tooltip="Email notifications are only available for users with full access or billing access."><Glyph name="question-2" /></span></h4>);
}

export default NotificationPreferences;
